import { render, staticRenderFns } from "./Monoidal.vue?vue&type=template&id=30027be6&scoped=true&"
import script from "./Monoidal.vue?vue&type=script&lang=js&"
export * from "./Monoidal.vue?vue&type=script&lang=js&"
import style0 from "./Monoidal.vue?vue&type=style&index=0&id=30027be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30027be6",
  null
  
)

export default component.exports